import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    kycRes: [],
    error: "",
}

const kycSlice = createSlice({
    name: 'kycDetails',
    initialState,
    reducers: {
        kyc: (state, action) => {
            state.kycRes = action.payload
        }
    }
})

export const { kyc } = kycSlice.actions;
export default kycSlice.reducer;

export const uploadKyc = (data, type, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.KYC}`, data, type);
            callback(response)
            dispatch(kyc(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }